import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";


(function( $ ) {

    // Stop execution if this is the wizard page
    if (document.body.classList.contains("page-template-tpl-wizard")) return;

    $( function() {

        initFancybox();

    });
} ) ( jQuery );

export function initFancybox() {
    Fancybox.bind('[data-fancybox="gallery"]', {
        Toolbar: {
            display: [
                "zoom", // Optional, remove if you don't want zoom either
                "close" // Keep only what you want
            ]
        }
    });

    Fancybox.bind('[data-fancybox="video"]', {
        Toolbar: {
            display: [
                "zoom", // Optional, remove if you don't want zoom either
                "close" // Keep only what you want
            ]
        }
    });
}
